import { render, staticRenderFns } from "./ScoreRuleDialog.vue?vue&type=template&id=187d3024&scoped=true&"
import script from "./ScoreRuleDialog.vue?vue&type=script&lang=ts&"
export * from "./ScoreRuleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d3024",
  null
  
)

export default component.exports